/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import './pagination';
import '../model/shared/device';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "message": {
                    "nested": {
                      "GetDevicesLinkedToProfileV2Request": {
                        "fields": {
                          "deviceProfileId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "pagination": {
                            "type": ".squareup.devicesettings.profiles.v2.message.Pagination",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "GetDevicesLinkedToProfileV2Response": {
                        "fields": {
                          "device": {
                            "type": ".squareup.devicesettings.profiles.v2.model.shared.Device",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "nextCursor": {
                            "type": "uint32",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.message?.nested?.GetDevicesLinkedToProfileV2Request && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.message?.nested?.GetDevicesLinkedToProfileV2Response) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE GetDevicesLinkedToProfileV2Request @ squareup/devicesettings/profiles/v2/message/get_devices_linked_to_profile.proto at 11:1
 */
export const GetDevicesLinkedToProfileV2Request = $root.lookupType('squareup.devicesettings.profiles.v2.message.GetDevicesLinkedToProfileV2Request');
fixType(GetDevicesLinkedToProfileV2Request);
Builder.createAndAttachToType(GetDevicesLinkedToProfileV2Request);
/**
 * SOURCE GetDevicesLinkedToProfileV2Response @ squareup/devicesettings/profiles/v2/message/get_devices_linked_to_profile.proto at 16:1
 */
export const GetDevicesLinkedToProfileV2Response = $root.lookupType('squareup.devicesettings.profiles.v2.message.GetDevicesLinkedToProfileV2Response');
fixType(GetDevicesLinkedToProfileV2Response);
Builder.createAndAttachToType(GetDevicesLinkedToProfileV2Response);